export const TYPES      = ['E-Reader', 'Laptop', 'Tablet'];
export const IMAGE_SETS = ['6_7_8_ereader_square', '6_7_8_ereader_rectangle', '12_13_14_Laptop','15_16_17_Laptop', '8_9_Tablet', '10_11_Tablet', '12+_Tablet' ];

